import React from 'react'
import { Alert } from '@material-ui/lab'
import { getJackpotErrors } from '../../api/jackpot'

const JackpotError: React.FC<{ error: unknown }> = ({ error }) => (
  <>{getJackpotErrors(error).map((item, index) => <Alert severity="error" key={index}>{item.message}</Alert>)}</>
)

export default JackpotError
